import { useState } from 'react';
import "./read-more-less.css";

const ReadMoreReadLessVision = ({ 
  className = 'read-more-less', 
  buttonClassName = 'btn-read-more-less', 
  expandLabel, 
  collapseLabel, 
  limit,         
  expandedLimit, 
  noReadMore = false, // Nueva propiedad (por defecto false)
  children 
}) => {
  const [isReadMoreShown, setIsReadMoreShown] = useState(false);

  const textString = children ? String(children).trim() : '';
  const totalLength = textString.length;

  // Si el texto original es más corto que el primer límite, se muestra todo sin botón
  if (totalLength <= limit) {
    return <div className={className}>{textString}</div>;
  }

  // Si noReadMore es true, el límite se clava en el inicial. Si es false, sigue la lógica anterior.
  const currentLimit = noReadMore 
    ? limit 
    : (isReadMoreShown ? expandedLimit : limit);

  // ¿El texto real es más largo que el límite visible actual?
  const hasMoreText = totalLength > currentLimit;

  // Cortamos el texto y evaluamos si lleva "..." al final
  const textToShow = hasMoreText 
    ? textString.substring(0, currentLimit) + '...' 
    : textString;

  const toggleBtn = () => {
    setIsReadMoreShown(prevState => !prevState);
  };

  return (
    <div className={className}>
      {textToShow}
      {/* El botón SOLO se renderiza si noReadMore es false */}
      {!noReadMore && (
        <button className={buttonClassName} onClick={toggleBtn}>
          {isReadMoreShown ? collapseLabel : expandLabel}
        </button>
      )}
    </div>
  );
};

export default ReadMoreReadLessVision;
